const HTTP_PROTOCOLS = new Set(['http:', 'https:']);

/**
 * Returns a normalized http(s) URL, or `null` when `value` is missing, not a
 * valid URL, or uses a non-http(s) scheme.
 *
 * Prefer this over `z.string().url()` or a prefix check when the value is
 * passed to `window.open()` or used as an `href`: those accept schemes such
 * as `javascript:` that can execute in the opener's context.
 */
export const toHttpUrl = (value?: string | null) => {
  if (!value) return null;

  try {
    const url = new URL(value);
    if (!HTTP_PROTOCOLS.has(url.protocol)) return null;

    return url.href;
  } catch {
    return null;
  }
};

export const isHttpUrl = (value?: string | null) => toHttpUrl(value) !== null;

export const getCurrentSearchParams = (): URLSearchParams =>
  new URLSearchParams(window.location.search);

export const setOrDeleteSearchParam = (
  params: URLSearchParams,
  key: string,
  value?: string | null
) => {
  if (value) params.set(key, value);
  else params.delete(key);
};
